import styled from 'styled-components';

import colors from '@theme/colors';

export const FieldInput = styled.input`
  display: block;
  font-family: GTAmerica;
  width: 100%;
  width: -moz-available;
  width: -webkit-fill-available;
  width: fill-available;
  height: 56px;
  appearance: none;
  font-size: 14px;
  letter-spacing: 0.5px;
  box-shadow: none;
  border-radius: 0px;
  padding: 0 25px;
  color: ${({ dark }) => (dark ? colors['charcoal'] : colors['charcoal'])};
  background-color: ${colors['white']};
  border: ${({ error }) =>
    error ? `solid 2px ${colors['error-red']}` : 'none'};

  &:focus {
    outline: none;
  }
  &::placeholder {
    color: ${colors['charcoal']};
    opacity: 0.54;
  }
  &::-ms-clear {
    width: 0;
    height: 0;
  }
`;
